import {defineMessages} from 'react-intl';

const messages = defineMessages({
  createDispatch: {
    id: 'createDispatch',
    defaultMessage: 'Create Dispatch'
  },
  dispatchSent: {
    id: 'dispatchSent',
    defaultMessage: 'Dispatch Sent'
  }
});

export default messages;
